import React from 'react';
import { MAIN_MENU } from '../../utils';
import SystemComponents from '../SystemComponent';
import './styles.scss';

const ElementsList = () => <SystemComponents componentObj={MAIN_MENU.elements} />;

export default ElementsList;
